// React
import React, { Component } from "react";

// Components
import { MessageBox } from '../../Components';

// Routes
import { LoginRoutes } from '../../Routes';

// Stores
import { UserProfileStore } from '../../Stores';

// Utils
import { Validate } from '../../Utils';

// Libraries
var jwt_decode = require('jwt-decode');

/**********************************************************
 *    Login Panel Component
 * 
 *  - Validates the inputs for login/signup
 *  - Facilitates the login/signup process
 * 
 **********************************************************/

export class LoginTab extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/

    constructor(props) {

        super(props);

        this.state = {
            userIcon : 'icon-user ',
            username : '',
            password : '',
            message : null,
            activeTab : 'login'
        };
    }

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render
    componentDidMount() {

        //console.log('LoginTab.componentDidMount()');
    }


    // Determines whether or not the LoginTab should update
    shouldComponentUpdate(nextProps, nextState) {

        if(nextProps !== this.props || nextState !== this.state) {
            return true;
        }
        
        return false;
    }


/**********************************************************
 *  Validating Inputs
 **********************************************************/

    // Changes the value of username and validates on each keystroke
    updateUsername = (event) => {

        var updatedUsername = event.target.value;
        var _this = this;

        _this.setState((prevState,props) => {
            return {
                username: updatedUsername
            }
        });

    }


    // If user hits enter button on page,
    // treat as if they clicked login buton
    handleKeyPress = (target) => {

        if(target.charCode===13) {
            this.login();
        }
            
    }


    // Changes the value of password on each keystroke
    updatePassword = (event) => {

        var updatedPassword = event.target.value;
            
        this.setState((prevState,props) => {
            return {
                password: updatedPassword
            }
        });
    }


    // Displays a message box on login panel with given parameters
    displayMessage(title, details, type) {

        const msg = {
            title : title,
            details : details,
            type : type
        };

        this.setState((prevState,props) => {
            return {
                message : msg
            }
        });

    }

/**********************************************************
 *  Login
 **********************************************************/

    // Facilitates login request with username and password
    login = () => {

        // TODO: accept email or username
        // TODO: encrypt password before request

        var _this = this;

        //console.log('LoginTab.login()');

        const username = this.state.username.trim();
        const password = this.state.password; // no trim for passphrases
        
        const usernameErrors = Validate.username(username);
        const passwordErrors = Validate.password(password, username);

        if(usernameErrors.length === 0 && passwordErrors.length === 0) {

            var credentials = {
                "username" : username,
                "password" : password
            };

            LoginRoutes.login(credentials)
                .then( (token) => {

                    var decoded = jwt_decode(token);
                    var userProfile = decoded.user;

                    UserProfileStore.addUser(token);

                    if(userProfile !== null) {
                    
                        _this.props.history.push(
                            {
                                pathname: '/dashboard',
                                state: { loggedIn: true }
                            }
                        );
                    }

                })
                .catch( (error) => {

                    this.displayMessage('Login Failure', error.message, 'error');

                });
        }
        else {

            const errors = usernameErrors.join(' ') + passwordErrors.join(' ');

            this.displayMessage('Username/Password Error', errors, 'error');
        }

    }


/**********************************************************
 *  Render
 **********************************************************/

  // Renders the LoginTab Component with children:
  // LoginTabSettings and Pricer
  render() {

    var errorMessageRow = null;

    if(this.state.message !== null) {
        errorMessageRow = (
            <div className="row error-row">
                <div className="col-lg-10 col-lg-offset-1 col-sm-12">
                    <MessageBox message={this.state.message} />
                </div>
            </div>
        );
    }

    return (            

        <div>

            {/*-- row --*/}
            <div className="row">
                <div className="col-lg-10 col-lg-offset-1 col-sm-12">

                    <div className="splash-input">
                        <input type="text" placeholder="username"
                        onChange={this.updateUsername} onKeyPress={this.handleKeyPress}
                        value={this.state.username}></input>
                        <i className="icon-user"></i>
                    </div>

                </div>
            </div>
            {/*-- / row --*/}

            {/*-- row --*/}
            <div className="row">
                <div className="col-lg-10 col-lg-offset-1 col-sm-12">

                    <div className="splash-input" >
                        <input placeholder="password" type="password"
                        value={this.state.password} onChange={this.updatePassword} 
                        onKeyPress={this.handleKeyPress} ></input>
                            <i className="icon-lock text-size-xlarge"></i>
                    </div>

                </div>
            </div>
            {/*-- / row --*/}

            { errorMessageRow }

            {/*-- row --*/}
            <div className="row">
                <div className="col-lg-5 col-lg-offset-1 col-md-6 col-md-offset-0 col-sm-6 col-sm-offset-0 col-xs-7 col-xs-offset-0">
                </div>
                <div className="col-lg-5 col-lg-offset-0 col-md-5 col-md-offset-1 col-sm-6 col-sm-offset-0 col-xs-5">
                    <button type="button" className="btn btn-raised bg-pink-400 legitRipple pull-right splash-button"
                        onClick={this.login} onKeyPress={this.handleKeyPress}><span>LOGIN</span></button>
                </div>
            </div>
            {/*-- / row --*/}

        </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/Views/Login/LoginTab.js